// Telegram Mini App Authentication Hook

import { useEffect, useState } from 'react';
import { authApi } from '../../apiClients/auth';
import { storeTokens } from '../../lib/authUtils';
import { notificationStore } from '../../stores/NotificationStore';

export function useTelegramAuth() {
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const authenticateWithTelegram = async () => {
      // Check if we're in Telegram Mini App
      if (
        typeof window === 'undefined' ||
        !('Telegram' in window) ||
        !('WebApp' in window.Telegram)
      ) {
        // Not in Telegram Mini App, skip authentication
        setIsAuthenticating(false);
        return;
      }

      try {
        const telegram = window.Telegram.WebApp;

        // Initialize Telegram WebApp
        telegram.ready();

        // Set header color to match app theme (vertical blue to purple gradient)
        // Using blue color that matches the top of the gradient
        telegram.setHeaderColor('#2563EB'); // blue-600

        const initData = telegram.initData;

        if (process.env.REACT_APP_DEBUG_AUTH_ENABLED === 'true') {
          setIsAuthenticated(true);
          setIsAuthenticating(false);
          return;
        }

        if (!initData) {
          setIsAuthenticating(false);
          return;
        }

        // Authenticate with backend
        const response = await authApi.authenticateWithTelegram({
          initData,
        });

        // Store tokens in memory
        storeTokens(response.accessToken, response.refreshToken);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Telegram authentication failed:', error);
        notificationStore.showError('Failed to authenticate');
      } finally {
        setIsAuthenticating(false);
      }
    };

    authenticateWithTelegram();
  }, []); // Run only once on mount

  return { isAuthenticating, isAuthenticated };
}
